import {
  BasicTeamSerializedType,
  FolderHashidSerializedType,
  FolderSerializedType,
  ListResponseType,
  RawFolderHashidSerializedType,
  RawFolderSerializedType,
} from 'sweet-types';

export function rehydrateFoldersTeams(
  response: ListResponseType<RawFolderSerializedType, any>,
  basic_teams?: Record<number, BasicTeamSerializedType>
): ListResponseType<FolderSerializedType> {
  const results = response.results.map((folder) =>
    flatRehydrateFolderTeams(folder, basic_teams ?? {})
  );
  return {...response, results, related: undefined};
}

function flatRehydrateFolderTeams(
  folder: RawFolderSerializedType,
  basic_teams: Record<number, BasicTeamSerializedType>
): FolderSerializedType {
  const teams: Array<BasicTeamSerializedType> = folder.teams.map(
    (team) =>
      basic_teams?.[team.id] || {
        id: team.id,
        url: '',
        name: 'Untitled Team',
        content_type: 'team',
        hashid: '',
        html_url: '',
      }
  );
  return {
    ...folder,
    teams,
  };
}

export function rehydrateFolderHashidTeams(
  folder: RawFolderHashidSerializedType,
  basic_teams: Record<number, BasicTeamSerializedType>
): FolderHashidSerializedType {
  const teams: Array<BasicTeamSerializedType> = folder.teams.map(
    (team) =>
      basic_teams[team.id] || {
        id: team.id,
        url: '',
        name: 'Untitled Team',
        content_type: 'team',
        hashid: '',
        html_url: '',
      }
  );
  return {
    ...folder,
    teams,
    parent:
      folder.parent != null
        ? rehydrateFolderHashidTeams(folder.parent, basic_teams)
        : null,
  };
}
